import { ReactComponent as StepPast } from '../../../assets/icons/shield-check-fill.svg'
import { ReactComponent as StepCurrent } from '../../../assets/icons/step-current.svg'
import { ReactComponent as StepCurrentWarning } from '../../../assets/icons/step-current-warning.svg'
import { ReactComponent as StepError } from '../../../assets/icons/step-error.svg'
import { ReactComponent as StepDisabled } from '../../../assets/icons/step-disabled.svg'
import { ReactComponent as StepCancelled } from '../../../assets/icons/step-cancelled.svg'
import { ReactComponent as StepResolved } from '../../../assets/icons/step-resolved.svg'
import { ReactComponent as StepUnscheduled } from '../../../assets/icons/step-unscheduled.svg'
import { ReactComponent as StepSolvable } from '../../../assets/icons/step-error-solvable.svg'

export const DISABLED = 'disabled'
export const PAST = 'past'
export const CURRENT = 'current'
export const CURRENT_WARNING = 'current-warning'
export const ERROR = 'error'
export const CANCELLED = 'cancelled'
export const RESOLVED = 'resolved'
export const SOLVABLE = 'solvable'
export const UNSCHEDULED = 'unscheduled'

export const STATUS = {
  DISABLED,
  PAST,
  CURRENT,
  CURRENT_WARNING,
  ERROR,
  CANCELLED,
  RESOLVED,
  SOLVABLE,
  UNSCHEDULED
}

export const ICONS = {
  [DISABLED]: <StepDisabled />,
  [PAST]: <StepPast />,
  [CURRENT]: <StepCurrent />,
  [CURRENT_WARNING]: <StepCurrentWarning />,
  [ERROR]: <StepError />,
  [CANCELLED]: <StepCancelled />,
  [RESOLVED]: <StepResolved />,
  [SOLVABLE] : <StepSolvable />,
  [UNSCHEDULED] : <StepUnscheduled/>
}
